export default __webpack_public_path__ + "static/media/02_pleti-ve-foliovniku.3c426044.jpg";